//引入安装的signalr包
import * as signalR from "@aspnet/signalr";
import { getUSER, getGUID } from "./auth";

const signal = new signalR.HubConnectionBuilder() //服务器地址
  .withUrl("/api/chatHub", {
    accessTokenFactory: () => {
      const user = getUSER();
      return user ? user.token : getGUID();
    }
  })
  .build();

//获取服务器返回的数据
signal.on("wsconnect", connectid => {
  //获取当前用户的connectid
  signal.__connectid = connectid;
  console.log("获取到!", signal.__connectid);
});

//自动重连
async function start() {
  try {
    await signal.start();
  } catch (err) {
    console.log(err);
    console.log("重新连接!");
    setTimeout(() => start(), 5000);
  }
}

signal.onclose(async () => {
  //关闭的时候把connect设置为空
  console.log("已经断开!");
  signal.__connectid = null;
  await start();
});

//将创建的signal赋值给Vue实例
export default {
  //install方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
  install: function(Vue) {
    console.log("装载websocket!!!");
    Vue.prototype.signalr = signal;
  }
};



// WEBPACK FOOTER //
// ./src/signalR.js